import { getCurrentTime } from "./getCurrentTime";
import { initMessageActions } from "./initMessageActions";
import { reconcileMessageGrouping } from "./reconcileMessageGrouping";
import { splitRoleplayContentParts } from "./splitRoleplayContentParts";

function formatRoleplayContent(text) {
    if (!text || typeof text !== 'string') return text;

    // Normalize newlines and trim
    const cleanText = text.replace(/\r\n|\r/g, '\n').trim();
    if (!cleanText) return '';

    // If it already looks like HTML, don't double-process
    if (cleanText.includes('<p>') || cleanText.includes('<div')) return cleanText;

    const paragraphs = cleanText.split(/\n\s*\n/);
    let formattedHtml = '<div class="text-fancy space-y-4 whitespace-normal *:first:mt-0 *:last:mb-0">';

    paragraphs.forEach(paragraph => {
        const trimmedPara = paragraph.trim();
        if (!trimmedPara) return;

        // Split by quotes for dialogue vs narration
        const parts = splitRoleplayContentParts(trimmedPara);

        parts.forEach(part => {
            const partContent = part.trim();
            if (!partContent) return;

            if (/^["“'‘]/.test(partContent)) {
                // Dialogue
                formattedHtml += `<p class="whitespace-pre-wrap break-words"><em class="text-orange-200">${partContent}</em></p>`;
            } else {
                // Narration
                formattedHtml += `<p class="whitespace-pre-wrap break-words">${partContent}</p>`;
            }
        });
    });

    formattedHtml += '</div>';
    return formattedHtml;
}

export function appendAdminMessage(chatForm, messageValue, skipQuestionPreview = false) {
    const contentWrapper = chatForm.find('.g-chatform-content');
    let adminMessageTemplate = chatForm.find('.g-chatform-message[data-role="admin"]').first().clone().show();

    // Check if we should apply roleplay formatting
    // For now, we apply it if the session is flagged as and immersive roleplay 
    // or if the message value naturally looks like roleplay (contains quotes)
    const isRoleplay = chatForm.attr('data-is-roleplay') === '1' || (typeof messageValue === 'string' && /["'“”]/.test(messageValue));

    if (messageValue && !skipQuestionPreview && typeof messageValue !== 'object') {
        contentWrapper.append(adminMessageTemplate);
    }

    /**
     * Fill admin message templates with data
     */
    if (messageValue && typeof messageValue !== 'object') {
        let displayValue = messageValue;
        if (isRoleplay) {
            displayValue = formatRoleplayContent(messageValue);
        }

        adminMessageTemplate.attr('data-message-text', messageValue);
        adminMessageTemplate.find('.g-chatform-message-content-inner').html(displayValue);
        adminMessageTemplate.find('.g-chatform-message-time').html(getCurrentTime(new Date));

        initMessageActions(adminMessageTemplate)
        reconcileMessageGrouping(contentWrapper);
    }

    return adminMessageTemplate;
}
